export class UserToken {
    constructor(
        public readonly access: string,
        public readonly refresh: string
    ) {
    }
}